import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=63bcc31d&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=63bcc31d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bcc31d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63bcc31d')) {
      api.createRecord('63bcc31d', component.options)
    } else {
      api.reload('63bcc31d', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=63bcc31d&scoped=true&", function () {
      api.rerender('63bcc31d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dRjAEyj5XSA4/JS/comp/Voucher.vue"
export default component.exports